module.exports = __webpack_public_path__ + "img/image-culture-2.fde907d2.png";